module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1501-cfe95249cdf2d73c3b91634883fd44ed.png";